export const configMap = {
  // 开发
  development: {
    rootPath: 'https://api-dev.sout.chat',
    realEnv: 'development',
    host: 'https://h5-test.sout.chat',
    activityHost: 'https://activity-dev.sout.chat', // 活动项目域名
  },
  // 测试
  testing: {
    rootPath: 'https://api-test.sout.chat',
    realEnv: 'testing',
    host: 'https://h5-test.sout.chat',
    activityHost: 'https://activity-test.sout.chat', // 活动项目域名
  },
  // 灰度
  gray: {
    rootPath: 'https://api-gray.sout.chat',
    realEnv: 'gray',
    host: 'https://h5-gray.sout.chat',
    activityHost: 'https://activity-gray.sout.chat', // 活动项目域名
  },
  production: {
    rootPath: 'https://api.sout.chat',
    realEnv: 'production',
    host: 'https://h5.sout.chat',
    activityHost: 'https://activity.sout.chat', // 活动项目域名
  },
};

type Environment = 'development' | 'testing' | 'gray' | 'production';
const NODE_ENV: Environment = import.meta.env.MODE as Environment;

export function getConfig(env?: 'development' | 'testing' | 'gray' | 'production') {
  const config = configMap[env || NODE_ENV] || configMap['production'];
  const defaultConfig = {
    language: 'en',
    designWidth: 375,
    projectName: 'sout_hybrid',
    contactServiceTel: '+1(332)276-3365',
  };

  return Object.assign(defaultConfig, config);
}